export default __webpack_public_path__ + "static/media/EditorialNew-UltraBold.3f3cdb76.otf";